module.exports = __webpack_public_path__ + "static/media/1.ec004092.svg";